export {
  default as ServiceContractModalBase,
  type Characteristic,
} from './ServiceContractModalBase';
